import {
  AccountBalanceWalletRounded,
  HistoryRounded,
  AccountCircleRounded,
  SwapVert,
  Moving,
} from '@mui/icons-material';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  chat: getIcon('ic_chat'),
  user: getIcon('ic_user'),
  dashboard: getIcon('ic_dashboard'),
  loan: getIcon('ic_loan'),
  userList: getIcon('ic_user_list'),
};

const clientNavConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: 'management',
    items: [{
      title: 'Watchlist',
      path: PATH_DASHBOARD.bankerRole.watchlist.root,
      icon: <SwapVert sx={{ fontSize: '22px', color: 'primary.main' }} />,
      activeIcon: <SwapVert sx={{ fontSize: '22px', color: 'primary.main' }} />
    },
    {
      title: 'Trades',
      path: PATH_DASHBOARD.bankerRole.trades.root,
      icon: <Moving sx={{ fontSize: '22px', color: 'text.secondary' }} />,
      activeIcon: <Moving sx={{ fontSize: '22px', color: 'primary.main' }} />
    },
    {
      title: 'Portfolio',
      path: PATH_DASHBOARD.bankerRole.portfolio.root,
      icon: <AccountBalanceWalletRounded sx={{ fontSize: '22px', color: 'text.secondary' }} />,
      activeIcon: <AccountBalanceWalletRounded sx={{ fontSize: '22px', color: 'primary.main' }} />
    },
    {
      title: 'History',
      path: PATH_DASHBOARD.bankerRole.history.root,
      icon: <HistoryRounded sx={{ fontSize: '22px', color: 'text.secondary' }} />,
      activeIcon: <HistoryRounded sx={{ fontSize: '22px', color: 'primary.main' }} />
    },
    {
      title: 'Profile',
      path: PATH_DASHBOARD.bankerRole.profile.root,
      icon: <AccountCircleRounded sx={{ fontSize: '22px', color: 'text.secondary' }} />,
      activeIcon: <AccountCircleRounded sx={{ fontSize: '22px', color: 'primary.main' }} />
    },
      // {
      //   title: 'Chat',
      //   path: PATH_DASHBOARD.bankerRole.chat.root,
      //   icon: <ChatRounded sx={{ fontSize: '24px' }} />
      // }
    ]
  },
  // {
  //   subheader: 'accounts',
  //   items: [{ title: 'profile', path: PATH_DASHBOARD.bankerRole.profile.root, icon: ICONS.user }],
  // },
];

export default clientNavConfig;
